/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionMessageType } from "./ActionMessageType";
export const ActionMessage = core.serialization.object({
    type: ActionMessageType,
    content: core.serialization.string(),
});
